import moment from "moment";
import { colorForLabel } from "./seriesPalette";

/**
 * Adapter from the /dashboardfilter API row shape to the StatChart prop shape.
 *
 * Input row shape (preserved from existing backend):
 *   [{ _id: { month: "YYYY-MM" }, pending: 12, approved: 5, ... }, ...]
 *
 * Output:
 *   { categories: string[], series: [{ name, data, color, stack }] }
 */

const titleCase = (s) =>
  String(s)
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const STATIC_SERIES = {
  applicant: ["pending", "approved", "denied"],
  ticket2: ["open", "inprogress", "completed"],
  ticket3: ["open", "inprogress", "completed"],
  ticket4: ["open", "inprogress", "completed"],
  property: ["active", "inactive"],
  property_manager: ["active", "inactive"],
  leads: ["pending", "closed", "cancelled", "follow_up"],
  user_appointment: ["booked", "pending", "rejected", "canceled"],
  rent: ["collected", "pending"],
};

const LABEL_OVERRIDES = {
  inprogress: "In Progress",
  follow_up: "Follow Up",
};

const labelFor = (key) => LABEL_OVERRIDES[key] || titleCase(key);

export const mapDashboardSeries = (type, rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return { categories: [], series: [], isEmpty: true };
  }

  const categories = rows.map((r) =>
    r && r._id && r._id.month
      ? moment(r._id.month, "YYYY/MM").format("MMM YYYY")
      : ""
  );

  let keys;
  if (type === "ticket") {
    keys = Array.from(
      new Set(
        rows.flatMap((r) => Object.keys(r || {}).filter((k) => k !== "_id"))
      )
    );
  } else {
    keys = STATIC_SERIES[type] || STATIC_SERIES.applicant;
  }

  const series = keys.map((key, idx) => {
    const label = labelFor(key);
    return {
      name: label,
      stack: "total",
      data: rows.map((r) => Number((r && r[key]) || 0)),
      color: colorForLabel(key, idx),
      key,
    };
  });

  const total = series.reduce(
    (sum, s) => sum + s.data.reduce((a, b) => a + b, 0),
    0
  );

  return {
    categories,
    series,
    isEmpty: total === 0,
  };
};

export const sumKey = (rows, key) => {
  if (!Array.isArray(rows)) return 0;
  return rows.reduce((acc, r) => acc + Number((r && r[key]) || 0), 0);
};

export const sumKeys = (rows, keys) => {
  if (!Array.isArray(rows) || !Array.isArray(keys)) return 0;
  return keys.reduce((acc, k) => acc + sumKey(rows, k), 0);
};

export const trendForKeys = (rows, keys) => {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) =>
    keys.reduce((acc, k) => acc + Number((r && r[k]) || 0), 0)
  );
};
